// extracted by mini-css-extract-plugin
export default {"container":"group_container__iRoTF","header":"group_header__yt7bh","body":"group_body__a0JAz","intro":"group_intro__TKVjN","footer":"group_footer__8B6yX"};